import { render, staticRenderFns } from "./FileManagerFilesSelect.vue?vue&type=template&id=3b7ccffe&"
import script from "./FileManagerFilesSelect.vue?vue&type=script&lang=js&"
export * from "./FileManagerFilesSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports